<template>
  <div class="default-footer width-100">
    <div class="safe-area_width footer-con f-v-center">
      <!-- 导航区域 start -->
      <div class="nav-block f-layout">
        <p v-for="item in aFooter" :key="item.id" class="navs">
          <a :href="item.url" target="_blank" class="hover-text_theme">{{ item.text }}</a>
          <span class="division-line"> ┊ </span>
        </p>
        <p v-for="item in handleFooter" :key="item.id" class="navs" @click="handleFooterFun(item)">
          <span class="hover-text_theme">{{ item.text }}</span>
          <span class="division-line"> ┊ </span>
        </p>
      </div>
      <!-- 导航区域 end -->
      <div class="f-layout">
        <p>{{ footerInfo }}</p>
        <a
          v-for="item in keepOnRecordUrl"
          :key="item.id"
          :href="item.url"
          target="_blank"
          class="hover-text_theme ml--10"
          >{{ item.text }}</a
        >
      </div>

      <div class="keep-on-record f-v-center" @click="openKeepOnRecordUrl">
        <img :rc="`${imgPath}/oneold/layout/beian.png`" alt="" />
        <p>京公网安备 11010802022728号</p>
      </div>
      <div class="imgs">
        <a v-for="item in imgs" :key="item.id" :href="item.url" target="_blank">
          <img :src="item.image" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { imgPath, INDEX_URL_GJXX } from "@/utils/constants/constants";
import { keepOnRecordUrl, footerNav } from "@/utils/constants/gjxx_data_moudle";

export default {
  name: "GjxxFooter",
  components: {},
  data() {
    return {
      username: "",
      imgPath,
      imgs: [
        {
          id: 0,
          url: "https://www.12377.cn/",
          image: `${imgPath}oneold/layout/bot_1.gif`,
        },
        {
          id: 1,
          url: "http://www.bj.cyberpolice.cn/index.do",
          image: `${imgPath}oneold/layout/bot_2.gif`,
        },
      ],
      COPYRIGHT: `版权所有 2008-${new Date().getFullYear()} 北京千里马网信科技有限公司`,
    };
  },
  computed: {
    keepOnRecordUrl() {
      return keepOnRecordUrl;
    },
    footerNav() {
      return footerNav;
    },
    aFooter() {
      return this.footerNav.filter((item) => item.url);
    },
    handleFooter() {
      return this.footerNav.filter((item) => item.type);
    },
    footerInfo() {
      return this.COPYRIGHT + " " + INDEX_URL_GJXX;
    },
  },
  created() {},
  mounted() {},
  methods: {
    openKeepOnRecordUrl() {
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802022728", "_blank", "");
    },
    handleFooterFun(item) {
      if (item.id === 11) {
        // 如果点击是 收藏本站
        scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/variable.scss";
.default-footer {
  margin-top: 10px;
  border-top: 2px solid $theme-color;
  .footer-con {
    flex-direction: column;
  }

  .navs {
    margin-top: 10px;
    margin-bottom: 20px;
    display: flex;
    cc .division-line {
      margin: 0 6px;
    }
    &:nth-child(5) a {
      color: $theme-color;
    }
    &:last-child .division-line {
      display: none;
    }
  }

  .keep-on-record {
    cursor: pointer;
    margin: 20px 0;
    color: #aaa;
    img {
      margin-right: 6px;
    }
  }

  .imgs {
    img {
      margin: 0 4px;
    }
  }
}
</style>
